import { useCallback } from 'react';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import EmptyProviderState from './EmptyProviderState';
import { getProviderColumns } from './lib/providerColumns';
import { PROVIDER_FILTERS } from './lib/providerFilters';

const ProvidersTable = ({
  addProvider,
  providers,
  onRemove,
  fieldName,
  addProviderButton,
  setSelectedRows,
  className = 'h-[400px]',
  style
}) => {
  const isInNetwork = fieldName === 'in_network_providers';

  const defaultColumns = getProviderColumns(addProvider, onRemove);

  const handleSelect = (selectedNodes) => {
    if (!setSelectedRows) return;
    setSelectedRows(selectedNodes.map((node) => node?.data).filter(Boolean));
  };

  const getRowId = useCallback((params) => params.data?.id ?? params.data?.value, []);

  const noRowsOverlayComponent = useCallback(
    () => (
      <EmptyProviderState
        addProvider={addProvider}
        isInNetwork={isInNetwork}
        addProviderButton={addProviderButton}
      />
    ),
    [addProvider, isInNetwork, addProviderButton]
  );

  const useProvidersTableData = ({ params }) => {
    let filteredProviders = providers;

    if (params?.filters) {
      filteredProviders = filteredProviders.filter((provider) => {
        return Object.entries(params.filters).every(([column, value]) => {
          return value.every(({ formula, values }) => {
            const isContains = formula === 'contains';
            const providerValue = String(provider?.[column] ?? '').toLowerCase();
            const filterValue = String(values ?? '').toLowerCase();
            const includesValue = providerValue.includes(filterValue);

            return isContains ? includesValue : !includesValue;
          });
        });
      });
    }

    const data = { providers: filteredProviders, count: filteredProviders.length };

    return { data };
  };

  return (
    <div className={className} style={style}>
      <AgTablePage
        noHeader
        noFilterActions
        name={addProvider ? 'add-network-providers' : 'payer-network-providers'}
        queryKey="providers"
        suppressMovableColumns={!addProvider}
        suppressDragLeaveHidesColumns={!addProvider}
        defaultColDef={{ suppressMenu: !addProvider }}
        noDisplayButton={!addProvider}
        useData={useProvidersTableData}
        defaultColumns={defaultColumns}
        defaultFilters={addProvider ? PROVIDER_FILTERS : {}}
        onSelect={handleSelect}
        noRowsOverlayComponent={noRowsOverlayComponent}
        rowSelection="multiple"
        suppressRowClickSelection={addProvider}
        getRowId={getRowId}
      />
    </div>
  );
};

export default ProvidersTable;
